import { render, staticRenderFns } from "./Vegetables.vue?vue&type=template&id=5930e368&scoped=true&"
import script from "./Vegetables.vue?vue&type=script&lang=js&"
export * from "./Vegetables.vue?vue&type=script&lang=js&"
import style0 from "./Vegetables.vue?vue&type=style&index=0&id=5930e368&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5930e368",
  null
  
)

export default component.exports